import React from "react";
import { Link, useLocation } from "react-router-dom";
import { CheckCircle2, XCircle, Clock } from "lucide-react";

export default function PaymentResult({ kind }) {
  const params = new URLSearchParams(useLocation().search);
  const cfg = {
    success: {
      icon: <CheckCircle2 size={56} className="text-emerald-500" />,
      title: "Payment Successful",
      sub: "Your plan is now active. A receipt is available on your Billing page.",
    },
    failed: {
      icon: <XCircle size={56} className="text-red-500" />,
      title: "Payment Failed",
      sub: params.get("reason") || "Your payment could not be completed. No amount was charged for failed attempts.",
    },
    pending: {
      icon: <Clock size={56} className="text-amber-500" />,
      title: "Payment Pending",
      sub: "We are waiting for confirmation from the bank. This usually takes a few minutes.",
    },
  }[kind] || {};

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F5F5F8] px-4">
      <div className="bg-white rounded-2xl border border-[#EDEDF1] shadow-sm p-10 max-w-md w-full text-center"
        data-testid={`payment-${kind}-page`}>
        <div className="flex justify-center mb-4">{cfg.icon}</div>
        <h1 className="text-2xl font-bold text-[#282C3F] mb-2">{cfg.title}</h1>
        <p className="text-sm text-[#535665] mb-6">{cfg.sub}</p>
        {kind === "success" && (
          <div className="text-left text-sm bg-[#F8F8FB] rounded-lg p-4 mb-6 space-y-1">
            {params.get("label") && <div><span className="text-[#94969F]">Plan/Service:</span> <b>{params.get("label")}</b></div>}
            {params.get("amount") && <div><span className="text-[#94969F]">Amount:</span> <b>₹{Number(params.get("amount")).toLocaleString("en-IN")}</b></div>}
            {params.get("inv") && <div><span className="text-[#94969F]">Invoice:</span> <b>{params.get("inv")}</b></div>}
            <div><span className="text-[#94969F]">Date:</span> <b>{new Date().toLocaleDateString("en-IN")}</b></div>
          </div>
        )}
        <div className="flex gap-3 justify-center">
          <Link to="/seller" className="px-5 py-2 rounded-md bg-[#FF3F6C] text-white text-sm font-semibold"
            data-testid="continue-dashboard-btn">
            Continue to Dashboard
          </Link>
          {kind !== "success" && (
            <Link to="/seller/billing" className="px-5 py-2 rounded-md border border-[#EDEDF1] text-sm text-[#535665]"
              data-testid="retry-payment-btn">
              Retry Payment
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
